<!--eslint-disable vue/no-mutating-props-->

<template>
  <fl-group name="Параметры ASR">
    <fl-select v-model="data.settings.asr_params.provider" label="Провайдер" :options="$options.asr.providers"/>
    <fl-select v-model="data.settings.asr_params.language" label="Язык" :options="$options.asr.langs[data.settings.asr_params.provider]"/>
    <fl-select v-model="data.settings.asr_params.grammar" label="Словарь" :options="$options.asr.grammar[data.settings.asr_params.provider]"/>
  </fl-group>
</template>

<script>
import FlGroup from "@/pages/flow/forms/components/FlGroup";
import FlSelect from "@/pages/flow/forms/components/FlSelect";

export default {
  components: {FlGroup, FlSelect},
  props: ["data"],
  asr: {
    providers: {
      yandex: "Яндекс",
      tinkoff: "Тинькофф",
    },
    langs: {
      yandex: {
        'ru-RU': "Русский",
        'en-US': "Английский",
        'tr-TR': "Турецкий",
      },
      tinkoff: {
        'ru-RU': "Русский",
        'en-US': "Английский",
      },
    },
    grammar: {
      yandex: {
        'general': "По умолчанию"
      },
      tinkoff: {
        'any': "По умолчанию"
      },

    }
  }

}
</script>
